import type { ControllerRenderProps, FieldValues, Path } from "react-hook-form";
import { useController, useFormContext } from "react-hook-form";

interface IReturn<TFieldValues extends FieldValues, TName extends Path<TFieldValues>> {
	error: string | undefined;
	field: ControllerRenderProps<TFieldValues, TName>;
}

interface IProps<TFieldValues extends FieldValues, TName extends Path<TFieldValues>> {
	name: TName;
}

export const useControl = <TFieldValues extends FieldValues, TName extends Path<TFieldValues>>({
	name,
}: IProps<TFieldValues, TName>): IReturn<TFieldValues, TName> => {
	const { control } = useFormContext<TFieldValues>();
	const {
		field,
		fieldState: { error },
	} = useController({
		name,
		control,
	});

	return { error: error?.message, field };
};
